import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { Checkbox } from 'semantic-ui-react'
import DeleteIcon from '@commonComponents/deleteIcon'
import { useTranslation } from '@hooks/useTranslation'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'


const ContainerTabForm = (props) => {
  const {
    dataSource: {
      id,
      containerNumber,
      sealNumber,
      sizeType,
      totalPackages,
      grossMass,
      unloaded,
      control,
      ...restdataSource
    },
    repeatableSealNumber,
    docTypeList,
    onChange,
    onSelect,
    onBlur,
    deleteData,
    tableName, 
    disabled, 
    isContainerDisabled,
    markedDeleted
} = props 
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id}),[tableName,id,onBlur])
  const translate = useTranslation();
  const { isDisabled } = useCurrentShipmentType();
  return (
    <div className='formContainer'>
      <Grid.Row>
        <Grid.Column>
          <InputField
            id={`containers${id}`}
            boxNumber={'7/10'}
            type='text'
            label='CONTAINERS'
            name="containerNumber"
            value={containerNumber}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={disabled||isContainerDisabled||null}
          />
        </Grid.Column>
        <Grid.Column style={{display:'flex'}}>
          {repeatableSealNumber ? repeatableSealNumber : (
            <InputField
              id={`seal${id}`}
              type='text'
              label='SEAL'
              boxNumber={'7/18'}
              name='sealNumber'
              value={sealNumber}
              clearInput={false}
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              isDisabled={isContainerDisabled||null}
            />
          )}
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`size${id}`}
            type='text'
            label='SIZE'
            boxNumber={'7/11'}
            name="sizeType"
            value={sizeType}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={disabled||isContainerDisabled||null}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`totalPkgs${id}`}
            type='text'
            label='TOTAL_PKGS'
            name="totalPackages"
            value={totalPackages}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={disabled||isContainerDisabled||null}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`grossMass${id}`}
            type='text'
            label='GROSS_MASS_KG'
            name="grossMass"
            value={grossMass}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={disabled||isContainerDisabled||null}
          />
        </Grid.Column>
        <Grid.Column>
          <Checkbox style={{ padding: '10px', verticalAlign: 'milddle' }}
            label={translate('UNLOADED')} 
            checked={unloaded == "1" ? true : false}
            disabled={ disabled === false ? false : (isDisabled||isContainerDisabled||null) }
            name='unloaded'
            onChange={(event,data)=>onSelect(id,tableName,{unloaded:data.checked?"1":"0",id})}
          />
        </Grid.Column>
        <Grid.Column>
          <Checkbox style={{ padding: '10px', verticalAlign: 'milddle' }} 
            {...disabled}
            label={translate('CONTROL')}
            disabled={ disabled === false ? false : (isDisabled||isContainerDisabled||null) }
            checked={control=="1" ? true :false}
            name='control'
            onChange={(event,data)=>onSelect(id,tableName,{control:data.checked?"1":"0",id})}
          />
        </Grid.Column>
      </Grid.Row>
      <div className='actionbtns'>
        {markedDeleted?markedDeleted({id, tableName}):
        <DeleteIcon onClick={() => deleteData(id, tableName)} isDisabled={disabled} />}
      </div>
    </div>
  )
}
ContainerTabForm.defaultProps = {
  translate: (value) => value,
}
export default React.memo(ContainerTabForm)
